export const accept = 'image/png, image/jpg, image/jpeg';
